import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { notifyMessage, notifyProblem } from '@/services/notify'

export const methods = {
  populateFromState() {
    try {
      console.debug('populateFromState...')
      let tempDescription = ''

      tempDescription = this.communicationDescription

      this.formData.supportMailDelivery = this.mailingType === 'Mail' ? true : false
      this.formData.supportEmailDelivery = this.mailingType === 'Email' ? true : false
      this.formData.supportSMSDelivery = this.mailingType === 'SMS' ? true : false
      this.formData.isLegalCommunication = this.isLegalCommunication

      console.debug('this.mailingTypeID===' + this.mailingTypeID)

      this.formData.mailingTypeID = this.mailingTypeID
        ? this.mailingTypeID
        : this.formData.mailingTypeID
      this.formData.description = tempDescription

      this.processDeliveryTypes()
    } catch (e) {
      console.debug('There was an error in populateFromState=' + e)
    }
  },

  async saveDescriptionChange() {
    console.debug('saveDescriptionChange....')
    this.descriptionIsStarted = true
    this.$store.dispatch('communication/saveDescription', {
      communicationDescription: this.formData.description
    })

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })
  },

  async descriptionBlur() {
    console.debug('descriptionBlur...')
    await this.saveDescription(true)
  },

  async saveDescription(displayNotification) {
    console.debug('in saveDescription...')

    if (
      (this.formData.supportMailDelivery === false &&
        this.formData.supportEmailDelivery === false &&
        this.formData.supportSMSDelivery === false) ||
      this.mailingType === ''
    ) {
      notifyProblem(
        'Please select at least one delivery method. You currently do not have a delivery method selected.'
      )
      return
    }

    if (this.formData.description === undefined || !this.formData.description) {
      if (
        displayNotification !== undefined &&
        displayNotification &&
        displayNotification === true
      ) {
        notifyProblem('A description is required.')
      }
      return
    }

    if (this.formData.mailingTypeID === undefined || this.formData.mailingTypeID === 0) {
      if (
        displayNotification !== undefined &&
        displayNotification &&
        displayNotification === true
      ) {
        notifyProblem('A mailing type selection is required.')
      }
      return
    }

    this.$store.dispatch('communication/saveDescription', {
      communicationDescription: this.formData.description
    })

    this.$store.dispatch('communication/saveMailingTypeID', {
      mailingTypeID: this.formData.mailingTypeID
    })

    this.$store.dispatch('communication/saveIsLegalCommunication', {
      isLegalCommunication: this.formData.isLegalCommunication
    })

    if (this.communicationID !== undefined && this.communicationID && this.communicationID > 0) {
      const params = {
        communicationID: this.communicationID,
        description: this.formData.description,
        mailingTypeID: this.formData.mailingTypeID,
        isLegalCommunication: this.formData.isLegalCommunication,
        supportMailDelivery: this.mailingType === 'Mail',
        supportEmailDelivery: this.mailingType === 'Email',
        supportSMSDelivery: this.mailingType === 'SMS',
        supportPushDelivery: this.formData.supportPushDelivery
      }

      console.debug('in updateCommunicationMessage() params=' + JSON.stringify(params))

      await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
        params,
        done: async ({ detail }) => {
          this.$store.dispatch('communication/saveIsEdit', {
            isEdit: true
          })

          if (detail) {
            if (displayNotification && displayNotification === true) {
              notifyMessage('General information has been saved.')
            }
          }
        }
      })
    } else {
      //Add new communication
      await this.addCommunication(displayNotification)
    }
  },

  async addCommunication(displayNotification) {
    console.debug(
      'in saveDescription adding communication...' +
        this.communicationID +
        ', ' +
        this.mailingTypeID +
        ', ' +
        this.isLegalCommunication
    )
    if (
      this.communicationID !== undefined &&
      this.communicationID <= 0 &&
      !this.communication &&
      this.mailingTypeID !== undefined &&
      this.mailingTypeID &&
      this.mailingTypeID > 0
    ) {
      const payload = {
        hoaID: this.hoaId,
        compositionMethod: 'html',
        htmlContent: '',
        htmlEmailContent: '',
        htmlSmsContent: '',
        documentID: null,
        mailingTypeID: this.formData.mailingTypeID || this.mailingTypeID,
        supportMailDelivery: this.mailingType === 'Mail',
        supportEmailDelivery: this.mailingType === 'Email',
        supportSMSDelivery: this.mailingType === 'SMS',
        supportPushDelivery: this.formData.supportPushDelivery,
        isLegalCommunication: this.formData.isLegalCommunication,
        emailSubject: '',
        emailPriority: '',
        smsSubject: '',
        pushSubject: '',
        deliveryAudience: '',
        description: this.formData.description || 'In Progress...'
      }

      await mailingCommunicationStore.dispatch('addCommunication', {
        payload,
        done: async ({ detail }) => {
          if (detail) {
            console.debug('add communication=' + JSON.stringify(detail))

            this.communicationID = detail.communicationID

            this.$store.dispatch('communication/saveSessionCommunicationID', {
              mailingCommunicationID: this.communicationID
            })

            this.$store.dispatch('communication/saveIsEdit', {
              isEdit: true
            })

            if (displayNotification && displayNotification === true) {
              notifyMessage('General information has been saved.')
            }
          }
        }
      })
    }
  },

  processDeliveryTypes() {
    console.debug('in processDeliveryTypes...' + this.mailingType)
    if (this.mailingType === 'Mail' || this.supportMailDelivery === true) {
      this.$store.dispatch('communication/saveSupportMailDelivery', {
        supportMailDelivery: true
      })
    } else if (this.mailingType === 'Email' || this.supportEmailDelivery === true) {
      this.$store.dispatch('communication/saveSupportEmailDelivery', {
        supportEmailDelivery: true
      })
    } else if (this.mailingType === 'SMS' || this.supportSMSDelivery === true) {
      this.$store.dispatch('communication/saveSupportSMSDelivery', {
        supportSMSDelivery: true
      })
    }
  },

  async reload() {
    console.debug('in general info reload...')
    this.loading = true

    this.communicationID = this.$route.params.id || 0

    console.debug('redirected communicationID=' + this.communicationID)

    if (this.communicationID !== undefined && this.communicationID) {
      this.$store.dispatch('communication/saveSessionCommunicationID', {
        mailingCommunicationID: this.communicationID
      })
    }

    if (this.isDebug == true) console.debug('mailingCommunicationID=' + this.mailingCommunicationID)

    this.processDeliveryTypes()

    this.loadMailingTypeList()

    this.changeMailingsByMailType()

    try {
      const id = this.mailingCommunicationID ? this.mailingCommunicationID : this.communicationID
      if (id > 0) {
        await mailingCommunicationStore
          .dispatch('getCommunicationById', {
            communicationID: this.mailingCommunicationID
              ? this.mailingCommunicationID
              : this.communicationID
          })
          .then(({ result }) => {
            console.debug('communication2=' + JSON.stringify(result))

            //this.communication = result.results

            if (result != undefined && result && result.communicationID) {
              this.formData.mailingTypeID = result.mailingTypeID

              this.formData.description = result.description

              this.formData.isLegalCommunication = result.isLegalCommunication

              console.debug(
                'this.formData.isLegalCommunication===' + this.formData.isLegalCommunication
              )
            }
          })
      }
    } catch (e) {
      console.debug('error while loading reload communication update method:' + e)
    }

    this.loading = false
  },

  async loadMailingTypeList() {
    console.debug('loadMailingTypeList...')
    await mailingCommunicationStore.dispatch('getMailingTypeList').then(({ list }) => {
      if (list) {
        console.debug('mailingTypeList===' + JSON.stringify(list))
        this.mailingTypeList = list
        this.formData.mailingTypeID =
          this.communication !== undefined && this.communication && this.communication
            ? this.communication.mailingTypeID
            : 0
        console.debug('loadMailingTypeList...' + this.formData.mailingTypeID)

        console.debug('before mailingTypeID...')

        if (this.mailingType === 'Email') {
          const myMailingTypeID = list.filter(f => f.code === 'email-notice')
          this.formData.mailingTypeID = myMailingTypeID[0].value
          console.debug('Email this.formData.mailingTypeID=' + this.formData.mailingTypeID)
        }

        if (this.mailingType === 'SMS') {
          const myMailingTypeID = list.filter(f => f.code === 'owner-statement')
          this.formData.mailingTypeID = myMailingTypeID[0].value
          console.debug('Sms this.formData.mailingTypeID=' + this.formData.mailingTypeID)
        }

        if (this.formData.mailingTypeID) {
          this.$store.dispatch('communication/saveMailingTypeID', {
            mailingTypeID: this.formData.mailingTypeID
          })
        }
      }
    })
  },

  changeMailingsByMailType() {
    this.$store.dispatch('communication/saveMailingTypeID', {
      mailingTypeID: this.formData.mailingTypeID
    })
  },

  processSupportMail() {
    console.debug('processSupportMail...')
    this.$store.dispatch('communication/saveSupportMailDelivery', {
      supportMailDelivery: this.formData.supportMailDelivery
    })
  },

  processSupportEmailDelivery() {
    console.debug('processSupportEmailDelivery...')
    this.$store.dispatch('communication/saveSupportEmailDelivery', {
      supportEmailDelivery: false
    })
  },

  processSupportSMSDelivery() {
    this.$store.dispatch('communication/saveSupportSMSDelivery', {
      supportSMSDelivery: false
    })
  },

  processIsLegalCommunication() {
    this.$store.dispatch('communication/saveIsLegalCommunication', {
      isLegalCommunication: this.formData.isLegalCommunication
    })
  }
}
